//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { feedBack } from '@/api/my'
export default {
  data () {
    return {
        disabled: false,
        message: '',
        title: '投诉举报',
        form: {
            content: '',
            phone: '',
            trueName: ''
        }
    }
  },
  methods: {
    onClickLeft () {
      this.$router.goBack()
    },
    feedBack () {
      if (this.form.content === '') {
        this.$toast('请输入内容')
        return
      }
      this.disabled = true
      feedBack(this.form).then(res => {
        this.$toast('感谢您的反馈')
        this.disabled = false
        this.onClickLeft()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Mine/report.vue